export function SetObjFilter(anObj, includeIt, excludeList) {
  var index = -100;
  var objID = anObj.GetObjectID().toString();
  if (excludeList) index = excludeList.indexOf(objID);

  if (includeIt) {
    anObj["objfilter"] = "include";
    if (index >= 0) excludeList.splice(index, 1);
  } else {
    anObj["objfilter"] = "exclude";
    if (index == -1) excludeList.push(objID);
  }
}
